/**
 * Filipino: Workflows P5-4, ang mga hakbang na nagkokontrol ng usapan (kunin ang sagot ng bisita, i-lock / i-unlock ang
 * chat box, i-snooze, itakda ang wika) at ang mga opsyon ng reply buttons. Kapareho ng hugis ng English na teksto;
 * isinasama sa `engage.workflows`.
 */
export const workflowsConversation = {
  steps: {
    collect_reply: "Kunin ang sagot ng bisita",
    disable_reply: "I-disable ang pagsagot ng bisita",
    enable_reply: "I-enable ang pagsagot ng bisita",
    snooze: "I-snooze ang usapan",
    set_language: "Itakda ang wika",
  },
  summaries: {
    status_closed: "Isara ang usapan",
    status_resolved: "I-resolve ang usapan",
    collect_reply: "{{question}} (isi-save sa {{target}})",
    disable_reply: "Mga button at card na kasunod lang ang magagamit ng bisita",
    enable_reply: "Puwede nang mag-type ulit ang bisita",
    snooze_minutes_one: "I-snooze nang {{count}} minuto",
    snooze_minutes_other: "I-snooze nang {{count}} minuto",
    snooze_hours_one: "I-snooze nang {{count}} oras",
    snooze_hours_other: "I-snooze nang {{count}} oras",
    snooze_days_one: "I-snooze nang {{count}} araw",
    snooze_days_other: "I-snooze nang {{count}} araw",
    snooze_until: "I-snooze hanggang {{date}} ng {{time}}",
    snooze_office: "I-snooze hanggang magbukas ang opisina",
    set_language: "Wika: {{language}}",
  },
  exits: {
    replied: "Sumagot",
    noReply: "Walang sagot sa tamang oras",
    woke: "Kapag nagising",
    startOver: "Magsimula ulit",
  },
  incomplete: {
    reply_range: "Hindi puwedeng mas mahaba ang pinakamaikling sagot kaysa sa pinakamahaba",
    reply_format: "Piliin ang format na bagay sa pagsasave-an ng sagot",
    snoozeUntil: "Piliin ang petsa at oras ng pag-snooze",
  },
  fields: {
    replyQuestionHint: "Sa chat box sasagot ang bisita. Hindi umaabot sa assistant ang sagot nila.",
    replyFormat: "Format ng sagot",
    replyFormatHint: "Ang maling sagot ay uulitin nang isang beses; pagkatapos nito, ang assistant na ang sasagot.",
    replyFormats: { any: "Anumang teksto", email: "Email address", phone: "Phone number", number: "Numero", digits: "Mga digit lang" },
    replyFormatProblem: "Dapat email address o phone number ang sagot para ma-save doon.",
    replyLength: "Haba ng sagot",
    replyMin: "Pinakamaikling sagot",
    replyMax: "Pinakamahabang sagot",
    replyCharacters: "karakter",
    replyLengthHint: "Mula 1 hanggang {{max}} karakter.",
    replyRangeProblem: "Hindi puwedeng mas mahaba ang pinakamaikling sagot kaysa sa pinakamahaba.",
    repliedGoTo: "Pagkatapos ng sagot",
    repliedHint: "Pumili ng path, o ituloy ang susunod na hakbang.",
    noReplyAfter: "Tumigil sa paghihintay pagkaraan ng ilang sandali",
    noReplyAfterHint: "Kung walang sumagot sa tamang oras, iba ang tatahakin ng workflow o magtatapos ito.",
    noReplyUnattached: "Nagsisimula ang trigger na ito bago pa magkaroon ng usapan, kaya hindi mapuputol sa oras ang paghihintay ng sagot.",
    noReplyWait: "Hintayin ang sagot nang",
    noReplyGoTo: "Kung walang sumagot",
    noReplyHint: "Kung saan pupunta ang workflow kapag naubos ang oras.",
    snoozeIntro: "Aalis ang usapan sa listahan ng bukas at maghihintay sa Snoozed view ng Inbox. Kapag sumagot ang bisita o isang kasamahan, o nagsara ang usapan, magigising ito agad.",
    snoozeMode: "I-snooze",
    snoozeModes: { for: "Sa loob ng ilang sandali", until: "Hanggang isang oras", until_office_hours: "Oras ng opisina" },
    snoozeFor: "I-snooze nang",
    snoozeUntil: "I-snooze hanggang",
    snoozeDate: "Petsa",
    snoozeTime: "Oras",
    snoozeZone: "Sa time zone ng workspace ninyo ({{zone}}). Lalaktawan ang oras na lumipas na.",
    snoozeOfficeHint: "I-snooze hanggang sa susunod na pagbukas ng opisina ng agent. Kung bukas na ang opisina, o walang oras ng opisina, lalaktawan ang hakbang.",
    wokeGoTo: "Kapag nagising",
    wokeHint: "Pumili ng path, o ituloy ang susunod na hakbang.",
    snoozeInterruptedGoTo: "Kung may sumagot muna",
    snoozeInterruptedHint: "Sumagot ang bisita o isang kasamahan, o nagsara ang usapan. Kung saan pupunta ang workflow noon.",
    languageChoice: "Wika",
    languageHint: "Itinatakda ang wika ng usapan.",
    languages: { en: "English", fil: "Filipino", auto: "Awtomatikong tukuyin" },
    languageEffect: "Sa wikang ito sasagot ang assistant at susunod din dito ang mga linyang isinusulat ng Sagot. Hindi ito babaguhin ng awtomatikong pagtukoy. Ibinabalik ng “Awtomatikong tukuyin” ang pagpili.",
    lockHelp: "Nilo-lock ang chat box: mga button at card na kasunod lang ang magagamit ng bisita.",
    unlockHelp: "Pinapayagan ulit ang bisita na mag-type sa chat box.",
    lockLifts: "Kusang nawawala ang lock sa hakbang na Kunin ang sagot ng bisita o Hayaang sumagot ang assistant, sa paglilipat sa tao, at kapag natapos ang workflow.",
    lockIdle: "Walang sasagutan ang bisita pagkatapos ng lock na ito, kaya wala pa itong binabago.",
    startOver: "Magdagdag ng button na Magsimula ulit",
    startOverHint: "Huling button na nagbabalik sa bisita sa Path A. Kasama ito sa bilang ng 8 button.",
    startOverFirstPath: "Bumabalik sa Path A ang Magsimula ulit, kaya hindi ito maidaragdag sa Path A.",
    startOverFull: "Gamit na ang lahat ng {{max}} button. Mag-alis ng isa para maidagdag ang Magsimula ulit.",
    startOverGoes: "Pumupunta sa Path {{path}} ang Magsimula ulit. Maisasalin ang label nito sa tab na Mga Salin.",
    saveChoice: "Tandaan ang pinili",
    saveChoiceHint: "Sine-save ang label ng button na pinili ng bisita para magamit ng mga susunod na hakbang at kondisyon.",
    saveChoiceTo: "I-save ang piniling button sa",
  },
  builder: {
    channelNotes: {
      steps: {
        collect_reply: {
          web: "Web chat, web app at mobile: sa chat box ibinibigay ang sagot (hindi ito card). Naaayon sa format ang keyboard nito.",
          messenger: "Messenger: tanong na plain text; ang susunod na mensahe ang sagot.",
          email: "Email: nasa reply ang tanong; binabasa ang sagot sa itaas ng sinipi na teksto.",
          api: "Hindi tumatakbo sa developer API channel ang mga hakbang na nakikita ng bisita.",
        },
        disable_reply: {
          web: "Dini-disable ng web chat, web app at mobile ang chat box.",
          other: "Hindi maitatago ng Messenger, email at API ang chat box; ang mensaheng itinype ay sinasagot na parang pag-type sa card na hindi nagpapahintulot mag-type: uulitin nang isang beses, saka sasagot ang assistant.",
        },
        enable_reply: {
          web: "Ine-enable ulit ng web chat, web app at mobile ang chat box.",
          other: "Hindi kailanman itinatago ng Messenger, email at API ang chat box, kaya walang nagbabago roon.",
        },
        snooze: { behind: "Gumagana sa likod ng eksena: walang nakikita ang bisita, sa lahat ng channel." },
        set_language: { behind: "Gumagana sa likod ng eksena sa lahat ng channel. Susunod sa wika ang susunod na sagot ng assistant at ang mga naisalin na teksto." },
      },
    },
  },
  connectors: {
    fixedExit: "Nakatakda: laging pumupunta sa Path A",
  },
};
